module.exports = "https://bin.bnbstatic.com/_next/static/images/es3-ba5e53c59a8ec717ef1af599f92dbbd8.jpg";